import request, { GET_REQUEST } from '@helpers/request';
import { API_E_PROMOTION_PATH, API_E_PROMOTION_PUB_PATH } from '../env';
import axios from 'axios';
import { AgencyRole } from '@pages/EPromotion/Agency/AgencyCode.js';

const { VITE_API_URL } = import.meta.env;

const structurePaths = {
  detail: {
    getDetail: `${API_E_PROMOTION_PATH}/get-detail`,
    getProcessHistories: `${API_E_PROMOTION_PATH}/get-eapp-process-history`,
  },
};

export const getListOfValueService = ({
  lovTypes = [
    'AGT_TITLE',
    'AGT_CAT',
    'AGT_STAT_FLG',
    'COMPANY',
    'S_OTH_ADMISS_TYP',
  ],
  role,
}) => {
  if (role !== AgencyRole.AGENCY_AM_CANDIDATE) {
    return request(`${API_E_PROMOTION_PATH}/get-list-of-value`, {
      method: 'GET',
      params: { lovTypes: lovTypes.join(',') },
    });
  } else {
    return request(`${API_E_PROMOTION_PUB_PATH}/amc/get-list-of-value`, {
      method: 'GET',
      params: { lovTypes: lovTypes.join(',') },
    });
  }
};

export const saveESubmission = (preAM) => {
  const formData = new FormData();
  formData.append('preAM', JSON.stringify(preAM));
  if (preAM?.letterConfirm) {
    formData.append('letterConfirm', preAM?.letterConfirm);
  }

  for (let i = 0; i < preAM.otherDocs?.length; i++) {
    if (preAM?.otherDocs[i]) {
      formData.append('otherDoc', preAM.otherDocs[i]);
    }
  }

  return request(`${API_E_PROMOTION_PATH}/pre-am`, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const getAmCandidateDetailService = ({ preAMId, by }) => {
  let url;
  if (by) {
    url = structurePaths.detail.getDetail + `?preAMId=${preAMId}&by=${by}`;
  } else {
    url = structurePaths.detail.getDetail + `?preAMId=${preAMId}`;
  }
  return GET_REQUEST(url, null);
};

export const searchPreAMCandidateInformation = ({
  criteriaType,
  criteriaValue,
}) => {
  const data = {
    criteriaType,
    criteriaValue,
  };

  return request(`${API_E_PROMOTION_PATH}/search-am-candidate`, {
    method: 'POST',
    data,
  });
};

export const searchPreCandidateEPromotion = (data) =>
  request(`${API_E_PROMOTION_PATH}/search-pre-am`, {
    method: 'POST',
    data,
  });

export const getListStatusEPromotion = () =>
  request(`${API_E_PROMOTION_PATH}/status`, {
    method: 'GET',
  });

export const getESubProcessHistoryService = ({ aMCId }) =>
  request(`${API_E_PROMOTION_PATH}/get-esub-process-history?aMCId=${aMCId}`, {
    method: 'GET',
  });

export const cancelEPromotion = (aMCId) => {
  const data = {
    value: aMCId,
  };
  return request(`${API_E_PROMOTION_PATH}/cancel-esub`, {
    method: 'POST',
    data,
  });
};

export const getDocBufferedDataService = ({ docId, docName, role }) => {
  const data = { docId, docName };
  if (role !== AgencyRole.AGENCY_AM_CANDIDATE) {
    return request(`${API_E_PROMOTION_PATH}/get-doc-buffered`, {
      method: 'POST',
      data: data,
      responseType: 'blob',
    });
  } else {
    return request(`${API_E_PROMOTION_PUB_PATH}/amc/get-doc-buffered`, {
      method: 'POST',
      data: data,
      responseType: 'blob',
    });
  }
};

export const checkAMCandidateStep = (pAMId) => {
  return request(`${API_E_PROMOTION_PUB_PATH}/amc/steps`, {
    method: 'POST',
    data: { pAMId },
  });
};

export const validatePhone = ({ mobilePhone, pAMId, captcha, referenceNo }) => {
  return request(`${API_E_PROMOTION_PUB_PATH}/amc/generate-otp`, {
    method: 'POST',
    data: {
      mobilePhone: mobilePhone,
      pAMId: pAMId,
      captcha: captcha,
      referenceNo: referenceNo,
    },
  });
};

export const validateOTP = ({ mobilePhone, pAMId, otp }) => {
  return request(`${API_E_PROMOTION_PUB_PATH}/amc/verify-otp`, {
    method: 'POST',
    data: { mobilePhone: mobilePhone, pAMId: pAMId, otp: otp },
  });
};

export const reloadOtp = ({ mobilePhone, pAMId }) => {
  return request(`${API_E_PROMOTION_PUB_PATH}/amc/reload-otp`, {
    method: 'POST',
    data: { mobilePhone: mobilePhone, pAMId: pAMId },
  });
};

export const getKaptchaImage = (timestamp) => {
  return axios.get(`${VITE_API_URL}/captcha/kaptcha-image.do?${timestamp}`, {
    method: 'GET',
    responseType: 'blob',
  });
};

export const getESubmissionDetailForAMC = ({ preAMId }) => {
  return request(`${API_E_PROMOTION_PUB_PATH}/amc/get-detail`, {
    method: 'GET',
    params: { preAMId: preAMId },
  });
};

export const sendActionByAMC = ({ amcId, action }) => {
  return request(`${API_E_PROMOTION_PUB_PATH}/amc`, {
    method: 'POST',
    data: {
      amcId: amcId,
      by: 'AMC',
      action: action,
    },
  });
};

export const saveESubmissionByAMC = (preAM) => {
  const formData = new FormData();
  formData.append('preAM', JSON.stringify(preAM));

  if (preAM?.letterConfirm) {
    formData.append('letterConfirm', preAM?.letterConfirm);
  }

  for (let i = 0; i < preAM.otherDocs?.length; i++) {
    if (preAM?.otherDocs[i]) {
      formData.append('otherDoc', preAM.otherDocs[i]);
    }
  }

  return request(`${API_E_PROMOTION_PUB_PATH}/amc/save`, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const rejectByAD = ({ amcId, rejectReason, adComment }) => {
  return request(`${API_E_PROMOTION_PATH}/amc`, {
    method: 'POST',
    data: {
      amcId: amcId,
      comment: rejectReason,
      action: 'REJECT',
      by: 'AD',
      adComment: adComment,
    },
  });
};

export const getAosAssessment = ({ amcId, isRefresh }) => {
  return request(`${API_E_PROMOTION_PATH}/aos/assessment`, {
    method: 'GET',
    params: {
      id: amcId,
      isRefresh: isRefresh,
    },
  });
};

export const returnByAOS = ({
  amcId,
  comment,
  approveReturnByAOS,
  aosAssessment,
}) => {
  const body = {
    amcId: amcId,
    comment: comment,
    approveReturnByAOS: approveReturnByAOS,
    aosAssessment: aosAssessment,
  };

  const formData = new FormData();
  formData.append('request', JSON.stringify(body));

  return request(`${API_E_PROMOTION_PATH}/aos/return`, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const sendActionByAOSH = ({ amcId, action, comment }) => {
  return request(`${API_E_PROMOTION_PATH}/amc`, {
    method: 'POST',
    data: {
      amcId: amcId,
      by: 'AOSH',
      action: action,
      comment: comment,
    },
  });
};
